// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "input[data-v-9fba6714]{display:none}.cropper-container[data-v-9fba6714]{position:fixed;left:8px;right:8px;bottom:8px;top:8px;z-index:10}", ""]);
// Exports
module.exports = exports;
